import { render } from "./BlogRightSidebar.vue?vue&type=template&id=208e45be"
import script from "./BlogRightSidebar.vue?vue&type=script&lang=js"
export * from "./BlogRightSidebar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\digitaldistribution.io-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__